var _rect, _rect2, _rect3, _path, _circle, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPush(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 63,
    viewBox: "0 0 40 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 4.90161,
    width: 27.0492,
    height: 54.0984,
    rx: 2,
    fill: "white",
    stroke: "#236AC9",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6.90161,
    y: 5.80322,
    width: 25.2459,
    height: 45.082,
    rx: 1,
    fill: "#F2FAFF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 14.1147,
    y: 4,
    width: 10.8197,
    height: 3.60656,
    rx: 1,
    fill: "#236AC9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9414 35.2231L17.2322 33.3024C17.3638 33.2707 17.5696 33.2059 17.7495 33.0605C18.0605 32.8092 18.1356 32.4723 18.1483 32.2423L18.1659 31.9219L17.9675 31.6698C17.7307 31.369 17.2376 30.7068 16.8075 29.9081C16.3665 29.0892 16.0481 28.2288 16.0481 27.5072C16.0481 24.8117 17.8636 22.85 19.6407 22.85C21.4263 22.85 23.2329 24.7918 23.2329 27.4403C23.2329 28.1717 22.9073 29.0415 22.4541 29.8712C22.0118 30.6808 21.5026 31.3546 21.2506 31.6697L21.0603 31.9075L21.0644 32.2121C21.0675 32.4424 21.1126 32.7794 21.3755 33.0575C21.5464 33.2383 21.7614 33.3276 21.8659 33.3641L24.9668 35.0003C25.4432 35.3364 25.7421 35.7275 25.922 36.0648C26.0149 36.2389 26.0745 36.3957 26.1098 36.5186C26.1426 36.6324 26.1487 36.6965 26.1498 36.7077C26.15 36.7095 26.15 36.7099 26.15 36.709V37C26.15 38.1874 25.1874 39.15 24 39.15H14C12.8126 39.15 11.85 38.1874 11.85 37V36.709C11.85 36.4466 11.9595 36.1468 12.1787 35.856C12.3975 35.5658 12.6847 35.3411 12.9414 35.2231Z",
    stroke: "#236AC9",
    strokeWidth: 1.7
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31.623,
    cy: 39.6885,
    r: 5.68853,
    fill: "white",
    stroke: "#236AC9",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3934 39.3169L31.6229 41.918L38.3115 34.8579",
    stroke: "#2EA76D",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPush);
export default __webpack_public_path__ + "static/media/push.2bbdca5deac70f1d63775a0337aec0d1.svg";
export { ForwardRef as ReactComponent };